import React from 'react'
import './style.sass'

export default function ModuleCatalogoExtendido({...props}){
    return(
        <div className="moduleCatalogoEx">
            <p><span className="textCatalogoEx">Catálogo Extendido </span> </p>
        </div>
    )
}